// import { customersApi } from '@/api';

const receivedSamplesFilters = [
  {
    name: 'requestedAt',
    label: 'requestedAt',
    type: 'dateDay',
    // whereOperator: 'regexp',
  },
];

export default receivedSamplesFilters;
